import type { MarketingPreferencesStore } from '../domain/types'
import { useStore } from 'zustand'
import { marketingPreferencesStore } from './store'

export function useMarketingPreferencesStore<T>(selector: (state: MarketingPreferencesStore) => T): T {
  return useStore(marketingPreferencesStore, selector)
}
